import { render } from "./index.vue?vue&type=template&id=501d5767&scoped=true"
import script from "./component.js?vue&type=script&lang=js"
export * from "./component.js?vue&type=script&lang=js"

import "./style.sass?vue&type=style&index=0&id=501d5767&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-501d5767"

export default script